import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const LS_ORG = "aevum_active_org_v1";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aevum_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Attach the active workspace so backend can scope reads/writes by org_id.
  const orgId = localStorage.getItem(LS_ORG);
  if (orgId) config.headers["X-Org-Id"] = orgId;
  return config;
});

export default api;
